export default __webpack_public_path__ + "static/media/pic5.520f7713.jpg";